<template>
  <div>
    <div class="card">
      <div class="card-header card-header-flex mt-3">
        <div class="d-flex flex-column mr-3">
          <a-range-picker
            v-model="searching_period"
            :show-time="false"
            @change="handleDateFilter"
          >
            <a-icon
              slot="suffixIcon"
              type="smile"
            />
          </a-range-picker>
        </div>

        <div class="d-flex flex-column justify-content-center ml-auto">
          <a
            href="#"
            target="_blank"
            @click.prevent.stop="downloadExcel"
          >{{ $t('reports.common.excel_export') }} <a-icon type="download" /></a>
        </div>
      </div>
      <div class="card-body">
        <a-table
          :columns="columns"
          :data-source="data"
          :pagination="pagination"
          bordered
          :row-key="record => record.id"
          :row-class-name="renderRowClass"
          @change="handleTableChange"
        >
          <template
            slot="money"
            slot-scope="text, row"
          >
            <span v-if="text"> {{ text | money }} </span>
            <span v-else-if="row.total === -1"> 0 </span>
            <span v-else> -- </span>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { Modal } from 'ant-design-vue'
import reportService from '@/services/api/admin/reports/report-services'
import sellerService from '@/services/api/admin/stores/seller-service'
import excelReportService from '@/services/api/admin/reports/excel-report-services'

export default {
  name: 'OperationsJournal',
  components: {
  },
  data: function () {
    return {
      searching_period: [moment().startOf('month'), moment().endOf('month')],
      columns: [
        {
          title: this.$t('seller.self'),
          dataIndex: 'seller_company',
          customRender: (value, row, index) => {
            return {
              children: this.data && this.data.length === index + 1 ? this.$t('reports.common.total') : this.$l(value.title),
              attrs: {
                colSpan: this.data && this.data.length === index + 1 ? 4 : 1,
              },
            }
          },
        },
        {
          title: this.$t('seller.tin'),
          dataIndex: 'seller_company.tin',
          customRender: (value, row, index) => {
            return {
              children: value,
              attrs: {
                colSpan: this.data && this.data.length === index + 1 ? 0 : 1,
              },
            }
          },
        },
        {
          title: this.$t('reports.sales.contract'),
          children: [
            {
              title: this.$t('seller.billing.contract_number'),
              dataIndex: 'contract_number',
              customRender: (value, row, index) => {
                return {
                  children: value,
                  attrs: {
                    colSpan: this.data && this.data.length === index + 1 ? 0 : 1,
                  },
                }
              },
            },
            {
              title: this.$t('seller.billing.contract_date'),
              dataIndex: 'contract_date',
              customRender: (value, row, index) => {
                return {
                  children: this.$options.filters.dateFormatter(value, 'YYYY-MM-DD'),
                  attrs: {
                    colSpan: this.data && this.data.length === index + 1 ? 0 : 1,
                  },
                }
              },
            },
          ],
        },
        {
          title: this.$t('reports.sales.total_delivered'),
          dataIndex: 'delivered_total_sum',
          scopedSlots: { customRender: 'money' },
        },
        {
          title: this.$t('reports.common.unfinished_deliveries'),
          children: [
            {
              title: this.$t('reports.sales.paid'),
              dataIndex: 'in_progress_online',
              scopedSlots: { customRender: 'money' },
            },
            {
              title: this.$t('reports.sales.unpaid'),
              dataIndex: 'in_progress_offline',
              scopedSlots: { customRender: 'money' },
            },
          ],
        },
        {
          title: this.$t('reports.common.seller_commission'),
          children: [
            {
              title: this.$t('reports.common.for_acquiring'),
              dataIndex: 'seller_commission_delivered',
              scopedSlots: { customRender: 'money' },
            },
            {
              title: this.$t('reports.common.for_unisavdo_using'),
              dataIndex: 'section_commission_delivered',
              scopedSlots: { customRender: 'money' },
            },
          ],
        },
      ],
      data: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 50,
      },
      filter: {
        title: '',
      },
      sorting: {
        col: 'delivered_total_sum',
        order: 'asc',
      },
      companyInfo: {
        id: null,
        legal_name: null,
        tin: null,
        contract_number: null,
        contract_date: null,
      },
      loading: false,
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    showRegenerationResult(count) {
      Modal.success({
        title: this.$i18n.t('product_add.messages.regeneration_result'),
        content: count + '' + this.$i18n.t('product_add.messages.regeneration_result_count'),
      })
    },
    fetchData() {
      this.filter.date_from = this.searching_period[0].format('YYYY-MM-DD')
      this.filter.date_to = this.searching_period[1].format('YYYY-MM-DD')
      // this.filter.date_from = '2021-02-01'
      // this.filter.date_to = '2021-02-28'
      reportService.getSummarySales(this.pagination, this.sorting, this.filter)
        .then((response) => {
          if (response && response.data && response.data.content) {
            this.data = response.data.content
            this.pagination.total = response.data.pagination.total
          }
        })
    },
    handleDateFilter(dates, dateStrings) {
      console.log('invoked on change')
      this.searching_period = dates
      this.fetchData()
    },
    handleSearch(selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    handleTableChange(pagination, filter, sorter) {
      if (sorter.columnKey && sorter.order)
        this.sorting = {
          col: sorter.columnKey,
          order: sorter.order.replace('end', ''), // ascend -> asc | descend -> desc
        }
      else
        this.sorting = null

      Object.keys(filter).forEach(key => {
        if (filter[key] && filter[key].length === 1)
          this.filter[key] = filter[key][0]
        else
          this.filter[key] = null
      })

      this.pagination.current = pagination.current

      this.fetchData()
    },
    handleCompanySearch(companyId) {
      this.loading = true
      sellerService.getSeller(companyId).then((response) => {
        if (response && response.data && response.data.content) {
          const content = response.data.content
          this.companyInfo.id = content.id
          this.companyInfo.legal_name = content.legal_info.legal_name
          this.companyInfo.tin = content.legal_info.tin
          this.companyInfo.contract_number = content.billing_info.contract_number
          this.companyInfo.contract_date = content.billing_info.contract_date

          this.loading = false
          this.fetchData()
        }
      })
    },
    renderRowClass (record, index) {
      if (this.data && this.data.length === index + 1) {
        return 'custom-summary-class'
      }
    },
    downloadExcel() {
      this.filter.date_from = this.searching_period[0].format('YYYY-MM-DD')
      this.filter.date_to = this.searching_period[1].format('YYYY-MM-DD')
      const fileName = 'Summary sales ' + this.filter.date_from + ' - ' + this.filter.date_to + '.xlsx'
      excelReportService.getSummarySalesExcel(this.pagination, this.sorting, this.filter, fileName)
    },
  },
}
</script>
<style>
.seller-table tr td:last-child {
  width: 116px !important;
}
.custom-summary-class {
  background: #f0f2f4;
}
</style>
